// React-Screen CPosDisabledMode ("Kassa noch nicht eroeffnet") - Strangler
// Phase 5, Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle posdisabledmode.js (aus
// lib/scripts/pos/components/CMP_CPosDisabledMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CPosDisabledMode.html, gezogen aus
// tests/visual-baseline/19-overlay-kasse-gesperrt.html.
//
// Das Overlay entsteht aus LYT_bonOverlay.xml (9 Kinder, kein CImage - anders
// als CAboutMode). Beide Buttons sind unsichtbar und ohne Handler; sie tragen
// nur die CPushButton-Standard-Listener (Dispatcher-Unlock).
//
// Zustand: showPrice() (aus CBonManager.addProduct bei displayMode == "info",
// domain/bon/bonentryops.js) tauscht contentText/priceText/unitsText aus.
// Legacy rief dafuer reDraw() auf den drei CCaptions - was sie im DOM ans
// ENDE des Overlays verschob; React rendert sie an ihrem Platz neu. Alle drei
// sind per CSS absolut positioniert und ueberlappen einander nicht, also ist
// das Bild identisch. Der Ausgangszustand (= Galerie-Baseline 19) ist
// zeichengleich.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style} dangerouslySetInnerHTML={{ __html: value }} />;
}

// Legacy-prepare()/restoreMainPos() sperren bzw. entsperren dieselben
// leftPad-Buttons. Diese Indizes bleiben beim Sperren bedienbar:
//   0 Sonderfunktionen, 2 Nachrichten, 4 Bankomat-Funktionen,
//   8 Benutzerfunktionen, 10 Kassa eroeffnen/abschliessen, 11 Abmelden.
//
// UMNUMMERIERT am 26.8.2026 (vorher 0, 2, 4, 9, 11, 12): der
// Funkscanner-Knopf auf Index 8 ist mit dem Geraet entfallen, alles danach
// rueckt um eins auf. WARUM DAS HIER BESONDERS WEH TAT: "Kassa eroeffnen"
// stand danach nicht mehr auf dieser Liste und wurde bei GESCHLOSSENER Kassa
// mitgesperrt - die Kassa liess sich nicht mehr oeffnen, und in der Folge
// scheiterte jeder Test, der einen Bon braucht.
// 12 = Ziertafel mit dem Geschaeftslogo (ohne Funktion). Sie steht mit auf
// der Liste, damit sie bei geschlossener Kassa nicht ausgegraut aussieht.
const KEEP_ENABLED = [0, 2, 4, 8, 10, 11, 12];

function setLeftPadEnabled(Main, enabled) {
  for (var i = 0; i < Main.components.leftPad.children.length; i++) {
    if (!enabled && KEEP_ENABLED.indexOf(i) > -1)
      continue;
    Main.components.leftPad.children[i].setEnabled(enabled);
  }
}

function PosDisabledModeScreen({ bridge }) {
  const t = bridge.t;
  // Beide Buttons: CPushButton-Standard-Events ohne Handler (nur Listener,
  // die den Dispatcher wieder entsperren) - genau wie im Legacy-Screen, der
  // properties.events nie anfasst.
  const passiveButton = {
    events: { onMousedown: true, onMouseout: true, onMouseup: true },
    proto: CPushButton.prototype,
  };

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute', visibility: 'visible' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'NO_BON_MODE')} />
      {/* contentText */}
      <Caption bridge={bridge} path="4" addclass="contenttext" value={bridge.state.contentText} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value={bridge.state.priceText} />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value={bridge.state.unitsText} />
      {/* okButton */}
      <div {...bridge.widget('7', 'CPushButton', passiveButton)} className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...bridge.widget('8', 'CPushButton', passiveButton)} className="CPushButton backbutton" style={{ visibility: 'hidden' }}>
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
    </>
  );
}

export const CPosDisabledMode = defineReactScreen({
  className: 'CPosDisabledMode',
  addclass: 'CPosDisabledMode CashWindow',
  htmlType: 'div',
  Screen: PosDisabledModeScreen,
  // Legacy-prepare() ohne den XML-/Property-Teil. bridge.Main setzt der
  // Aufrufer (CSessionHandler.addSession/disableAllPOSSessions) vor draw().
  prepare(bridge) {
    bridge.state.contentText = bridge.t('LABELS', 'NO_BON_MODE_TEXT');
    bridge.state.priceText = ' ';
    bridge.state.unitsText = ' ';

    bridge.Main.BonManager.displayMode = 'info';
    bridge.Main.BonManager.displayTarget = bridge;

    setLeftPadEnabled(bridge.Main, false);
  },
  methods: {
    // CBonManager.addProduct -> displayTarget.showPrice(parameters) mit
    // [Produkttext, Preis, Einheit]. Der Legacy-Zweig, der stattdessen
    // wholeText anzeigte, war auskommentiert - bleibt es.
    showPrice(bridge, parameters) {
      const prodText = parameters[0];
      const prodPrice = parameters[1];
      const prodUnit = parameters[2];

      bridge.update({
        contentText: prodText,
        priceText: prodPrice + ' &euro;',
        unitsText: 'pro ' + prodUnit,
      });
    },
    // CSessionHandler.enableAllPOSSessions (Kassa eroeffnen).
    restoreMainPos(bridge) {
      bridge.Main.BonManager.displayMode = 'normal';
      bridge.Main.BonManager.displayTarget = null;

      setLeftPadEnabled(bridge.Main, true);

      bridge.removeMe();
    },
  },
});
